import { HeroModele } from '@components/hero-modele/models';
import { kitchenMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const heroModeleMock: Block<HeroModele> = {
  type: 'hero-modele',
  data: {
    finishPageLink: '/nos-facades',
    kitchen: kitchenMock,
    gtmConfigPriceDetails: {
      event: 'click_cta_detail_prix',
      group: 'detail prix',
      description: 'page cuisine',
      context: 'detail prix {{modèle cuisine}}',
    },
  },
};
